import React from 'react';
import { Patient } from '../../types/patient';
import PatientsTable from '../PatientsTable';

export default ({ patients }: { patients: Patient[] }) => (
  <PatientsTable patients={patients} />
);